import React from 'react';
import classNames from 'classnames';
import { EFlyerFooterWeb } from '../EFlyerFooter';
import { MiniProduct } from 'app/common/components';
import { QRCallToActionWeb } from '../QRCallToAction';
import { ProductsContextType } from './ProductsContextType';

export const ProductsWeb = ({ context }) => {
  return (
    <div>
      <div id="header-container" className={'border-b-8 border-primary-600'}>
        <div
          id={'header'}
          className={'w-letter mx-auto flex flex-1 justify-between h-32'}
        >
          <div className="h-18 my-auto">
            <img
              src={context.logoUrl}
              alt={context.promoHeader}
              className="h-full object-contain mx-auto"
            />
          </div>
          <div className="text-primary-500 text-5xl text-center my-auto">
            {context.promoHeader}
          </div>
        </div>
      </div>
      <div id="main-container">
        <div id={'main'} className={'w-letter mx-auto'}>
          <div className="px-4 md:px-6 py-4 md:py-6 text-center text-2xl">
            {context.introText}
          </div>
          <hr className="mt-2 mb-6" />
          {/* Products Grid Skeleton */}
          {context.productIds.length > 0 && !context.productsLoaded ? (
            <div className="px-4 md:px-6 pb-4 md:pb-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
                {Array.from({
                  length: Math.min(context.productIds.length, 6)
                }).map((_, idx) => (
                  <div
                    key={idx}
                    className="animate-pulse border border-gray-200 rounded-md overflow-hidden bg-white"
                  >
                    <div className="w-full aspect-[4/3] bg-gray-100" />
                    <div className="p-3 md:p-4 space-y-2">
                      <div className="h-4 bg-gray-200 rounded w-3/4" />
                      <div className="h-4 bg-gray-200 rounded w-1/2" />
                      <div className="h-3 bg-gray-200 rounded w-full" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {/* Products Grid */}
          {context.productsLoaded ? (
            <div className="px-4 md:px-6 pb-4 md:pb-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
                {context.productIds.map((pid, idx) => {
                  const p = context.fetchedProducts.get(pid);
                  if (!p) return null;
                  return (
                    <MiniProduct
                      className={classNames('max-w-md')}
                      key={`${pid}-${idx}`}
                      product={p}
                      position={idx}
                      pricing={context.prices.get(pid)}
                    />
                  );
                })}
              </div>
            </div>
          ) : null}

          <div className={'ml-4 px-4'}>
            <QRCallToActionWeb
              callToAction={context.callToAction}
              qrUrl={context.qrUrl}
            />
          </div>
        </div>
      </div>
      <div id="footer-container" className={'bg-primary-600 mt-6'}>
        <div id={'footer'} className={'w-letter ml-auto mr-auto'}>
          <EFlyerFooterWeb footer={context.footer} />
        </div>
      </div>
    </div>
  );
};

ProductsWeb.propTypes = {
  context: ProductsContextType.isRequired
};

export default ProductsWeb;
